module.exports = __webpack_public_path__ + "static/media/gogreener_jejakin.e0dc58d9.svg";